export default "__VITE_ASSET__rmfA0pLm__"